import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { TOKEN_KEY, USER_KEY, REFRESH_KEY } from "../constants";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const stored = localStorage.getItem(USER_KEY);
    if (stored) { try { setUser(JSON.parse(stored)); } catch { localStorage.clear(); } }
    setLoading(false);
  }, []);
  const login = useCallback((userData, accessToken, refreshToken) => {
    localStorage.setItem(TOKEN_KEY,   accessToken);
    localStorage.setItem(REFRESH_KEY, refreshToken);
    localStorage.setItem(USER_KEY,    JSON.stringify(userData));
    setUser(userData);
  }, []);
  const logout = useCallback(() => { localStorage.clear(); setUser(null); }, []);
  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
